import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import CatalogoComercio from "../../../catalogos/catalogoComercio";

export default function ModalImprimirDeudasComerciales(props) {
  const op = require("../../../modulos/datos");
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(3), (val, index) => anioActual - index);
  const [selectAnio, setSelectAnio] = useState(anioActual);
  const [tipo, setTipo] = useState("BOLIVARES");
  const [simbolo, setSimbolo] = useState("BS");
  const [todos, setTodos] = useState(true);
  const [comercio, setComercio] = useState({
    idComercio: "",
    nomComercio: "",
  });
  const [showComercio, setShowComercio] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const imprimirReporte = () => {
    let condicion = " and 1=1";
    if (!todos && comercio && comercio.idComercio !== "") {
      condicion = ` and dj.idcomercio = ${comercio.idComercio}`;
    }
    try {
      window.open(
        op.reportes +
          "/actividadeconomica?" +
          `reporte=Listado_Deuda_Comercio&ANIO= anio >= ${selectAnio} &moneda=${tipo}&simbolo=${simbolo}&CONDICION=${condicion}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  const blanquear = () => {
    setTipo("BOLIVARES");
    setTodos(true);
    setSimbolo("Bs");
    setComercio({
      idComercio: "",
      nomComercio: "",
    });
    setShowComercio(false);
    setSelectAnio(anioActual);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
  };
  const salir = () => {
    props.setShow();
    blanquear();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          INFORME MENSUAL DE IMPUESTO DE ACTIVIDADES ECONÓMICAS
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between row col-md-12">
          <fieldset className="col-md-12 row mb-2 border-azul row rounded m-auto">
            <legend
              className="float-none w-auto fw-bold text-uppercase"
              style={{
                fontSize: "0.9rem",
              }}
            >
              Parametros del Reporte
            </legend>
            <div className="col-md-4">
              <div className="form-check d-inline-flex align-items-center">
                <label className="form-check-label d-flex align-items-center">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="filtro"
                    checked={todos}
                    onChange={(e) => {
                      setTodos(true);
                      setComercio({
                        idComercio: "",
                        nomComercio: "",
                      });
                    }}
                  />
                  Todos los Comercios
                </label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-check d-inline-flex align-items-center">
                <label className="form-check-label d-flex align-items-center">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="filtro"
                    checked={!todos}
                    onChange={(e) => {
                      setTodos(false);
                    }}
                  />
                  Filtrar Por Comercios
                </label>
              </div>
            </div>
            <div
              className="input-group input-group-sm mb-0 col-md-4"
              style={{ width: "100%" }}
            >
              <span className="input-group-text text-uppercase">
                A Partir Del Año
              </span>
              <select
                className="form-control text-uppercase"
                value={selectAnio}
                onChange={(e) => {
                  setSelectAnio(e.target.value);
                }}
              >
                {anios.map((e, index) => (
                  <option key={index} value={e}>
                    {e}
                  </option>
                ))}
              </select>
            </div>
          </fieldset>
          {!todos && (
            <fieldset className="col-md-12 row mb-2 border-azul row rounded m-auto">
              <legend
                className="float-none w-auto fw-bold text-uppercase"
                style={{
                  fontSize: "0.9rem",
                }}
              >
                Filtro de Comercio
              </legend>
              <div className="col-md-12">
                <div
                  className="input-group input-group-sm col-md-12 p-0 m-0 mb-0"
                  style={{
                    width: "100%",
                  }}
                >
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Comercio:
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled
                    value={comercio.nomComercio}
                    style={{
                      fontSize: "12px",
                    }}
                  />
                  <button
                    style={{ textAlign: "center", color: "white" }}
                    className="btn btn-sm btn-info"
                    onClick={() => setShowComercio(true)}
                  >
                    <i className="fas fa-search"></i>{" "}
                  </button>
                </div>
              </div>
            </fieldset>
          )}

          <fieldset className="col-md-12 row mb-2 border-azul row rounded m-auto">
            <legend
              className="float-none w-auto fw-bold text-uppercase"
              style={{
                fontSize: "0.9rem",
              }}
            >
              Tipo de Moneda
            </legend>
            <div className="row justify-content-center text-center">
              <div className="col-md-4">
                <div className="form-check d-inline-flex align-items-center">
                  <label className="form-check-label d-flex align-items-center">
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="tipoReporte"
                      value="BOLIVARES"
                      checked={tipo === "BOLIVARES"}
                      onChange={(e) => {
                        setTipo(e.target.value);
                        setSimbolo("Bs");
                      }}
                    />
                    Bolivares (Bs)
                  </label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-check d-inline-flex align-items-center">
                  <label className="form-check-label d-flex align-items-center">
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="tipoReporte"
                      value="UNIDAD"
                      checked={tipo === "UNIDAD"}
                      onChange={(e) => {
                        setTipo(e.target.value);
                        setSimbolo("€");
                      }}
                    />
                    Unidad (€)
                  </label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-check d-inline-flex align-items-center">
                  <label className="form-check-label d-flex align-items-center">
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="tipoReporte"
                      value="DOLAR"
                      checked={tipo === "DOLAR"}
                      onChange={(e) => {
                        setTipo(e.target.value);
                        setSimbolo("$");
                      }}
                    />
                    Dolar ($)
                  </label>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => imprimirReporte()}
          className="btn-sm rounded-pill btn btn-primary col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => blanquear()}
          className="btn-sm rounded-pill btn btn-warning col-md-2"
        >
          <i className="fa fa-trash"></i> Limpiar
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <CatalogoComercio
        show={showComercio}
        onHideCancelaCatCom={() => setShowComercio(false)}
        onHideAceptaCatCom={(idCome, nombre) => {
          setComercio({
            idComercio: idCome,
            nomComercio: nombre,
          });
        }}
      />
    </Modal>
  );
}
